import { Checkbox } from '@panwds/react-form-legacy'
import { Body } from '@panwds/react-ui'
import _ from 'lodash'
import { useMemo } from 'react'

import Addon from './Addon'

const BundleAddon = (props) => {
  const {
    bundleDisplayName,
    bundle,
    domainPostFix,
    cspDropDownData,
    loading,
    selectedTSGInstances,
    apps,
    selectedTreeNode
  } = props

  const addonComponents = useMemo(() => {
    return Object.values(_.groupBy(bundle, 'app_id')).map((addonLicenses, index) => {
      return (
        <div key={index}>
          <Addon key={index} {...{ addon: addonLicenses[0], domainPostFix, cspDropDownData, loading, selectedTSGInstances, apps, selectedTreeNode, displayCheckBox: false, useManifestDisplayName: true }} />
          {addonLicenses.map((license, licIndex) => {
            return <Body key={licIndex} addClassName="tw-font-lato tw-pl-12">{license.license_display_name}</Body>
          })}
        </div>
      )
      // return <Addon key={index} {...{ addon, domainPostFix, cspDropDownData, loading, selectedTSGInstances, apps, selectedTreeNode, displayCheckBox: false, useManifestDisplayName: true }} />
    })
  }, [apps, bundle, cspDropDownData, domainPostFix, loading, selectedTSGInstances, selectedTreeNode])
  return (
    <div>
      <div className="tw-flex tw-flex-1">
        <div className="tw-flex tw-flex-1">
          <div className="tw-flex tw-items-center tw-flex-1 tw-gap-2">
            <Checkbox
              label={bundleDisplayName}
              name={bundleDisplayName}
              showLabel={false}
              disabled
              checked={true}
              register={{
                required: false,
                value: true
              }}
            />
            <Body addClassName="tw-font-lato">{bundleDisplayName}</Body>
          </div>
        </div>
        <div className="tw-flex tw-items-center" style={{ flex: 2 }}></div>
      </div>
      <div className="tw-flex tw-flex-col">
        {addonComponents}
      </div>
    </div>
  )
}

BundleAddon.propTypes = {}
export default BundleAddon
